import React, { useState } from "react";
import { Button, TextField } from "@material-ui/core";
import Freeboard from "../Assets/freeboard.png";
import "./styles.css";
import { BsFacebook } from "react-icons/bs";

const Zoom = require("react-reveal/Zoom");
const Fade = require("react-reveal/Fade");
const Jump = require("react-reveal/Jump");

type Props = {
    enterLobby: (nickName: string) => void;
};

export const LandingPage = ({ enterLobby }: Props) => {
    const [nickname, setNickname] = useState("");
    return (
        <div>
            <div className="landing-page">
                <Jump>
                    <img className="landing-page__freeboard" src={Freeboard} alt="Quoridor board" />
                </Jump>
                <Fade>
                    <Zoom>
                        <div className="landing-page__right">
                            <h1 className="landing-page__title">Quoridor.io</h1>
                            <TextField
                                value={nickname}
                                onChange={(e) => setNickname(e.target.value)}
                                className="landing-page__nickname"
                                id="outlined-basic"
                                label="Nickname"
                                variant="outlined"
                            />
                            <Button
                                onClick={() => {
                                    if (nickname) {
                                        enterLobby(nickname);
                                    }
                                }}
                                className="landing-page__button"
                                variant="contained"
                                color="secondary"
                            >
                                Play
                            </Button>
                        </div>
                    </Zoom>
                </Fade>
            </div>

            <div className="landing-page__facebook">
                <BsFacebook
                    onClick={() => window.open("https://www.facebook.com/Quoridorio-103190198961367", "_blank")}
                />
            </div>
        </div>
    );
};
